import { getTimestamp } from '../getters/get-time-stamp';
import { deleteCookie, getCookie, setCookie } from '../helpers/cookie';
import { getSessionLifetime } from '../config/config';
import { CUSTOM_SESSION_ID_KEY, SESSION_ID_KEY } from '../config/constants';
import { scheduleStartSessionEvent } from './schedule-tech-events';
import { getDeviceId } from './device-id';

/**
 * Переопределение sessionId, установленного агентом clickstream
 * Чтобы отменить переопределение, вызовите deleteSessionId()
 * @param {String} value новое сессионное значение
 * @return {void}
 */
export const setSessionId = async value => {
  const customSessionId = getCookie(CUSTOM_SESSION_ID_KEY);
  if (value && customSessionId !== value) {
    // Установка специфичной сессии
    setCookie(CUSTOM_SESSION_ID_KEY, value, getSessionLifetime());
    scheduleStartSessionEvent(value);
  }
  const storedSessionId = customSessionId || getCookie(SESSION_ID_KEY);
  if (storedSessionId) {
    // Обновление срока жизни сессии
    setCookie(customSessionId ? CUSTOM_SESSION_ID_KEY : SESSION_ID_KEY, storedSessionId, getSessionLifetime());
  } else {
    // Установка сессии
    const deviceId = await getDeviceId();
    const sessionId = `${deviceId ?? ''}.${String(getTimestamp())}`;
    setCookie(SESSION_ID_KEY, sessionId, getSessionLifetime());
    scheduleStartSessionEvent(sessionId);
  }
};
export const getSessionId = () => {
  return getCookie(CUSTOM_SESSION_ID_KEY) || getCookie(SESSION_ID_KEY);
};

/**
 * Отмена переопределения sessionId, установленного агентом clickstream
 * @return {void}
 */
export const deleteSessionId = () => {
  deleteCookie(CUSTOM_SESSION_ID_KEY);
};